import { HOW_TO_EARN_POINTS_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { colorsNew } from 'root/src/client/web/commonStyles'
import { STREAMS_MINUTES_LIMIT } from 'root/src/shared/constants/campaignStreamingPointsRewards'

export default {
	[HOW_TO_EARN_POINTS_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalTitle: 'Drop Parameters',
		modalText:
			'Psssst... you are invited to the Private Beta of our new Points program!\nBut please keep it on the DL until we are ready for everyone to join.\nBelow is the criteria you need to follow to earn Points on this Drop',
		modalContent: {
			buttonText: 'CONTINUE',
			regularTerms: [
				{
					text: 'Put "Sponsored" or “Ad” in the stream title.',
					color: colorsNew.teal,
				},
				{
					preLinkText: 'Link to ',
					postLinkText: ' in chat.',
					color: colorsNew.primary,
					linkType: 'shortlink',
				},
				{
					text: ({ creatorCampaignPointsLimit }) => `Earn Points for up to ${STREAMS_MINUTES_LIMIT / 60} hour(s) streaming this game. (we predict you'll earn ${creatorCampaignPointsLimit} Points)`,
					color: colorsNew.yellow,
				},
				{
					text: 'Earn Dare rewards until the Dares expire.',
					color: colorsNew.pink,
				},
			],
			whitelistedTerms: [
				{
					text: ({ brandName }) => `You are a partner of ${brandName}, so you won\'t get points on this drop`,
					color: colorsNew.teal,
				},
				{
					text: 'But you can still earn Dare rewards until the Dares expire.',
					color: colorsNew.pink,
				},
			],
			termsAgreementText: 'I agree to the terms for earning Points on this Drop.',
		},
	},
}
